import { ColorOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentField } from '@icms/core/content';
import { NPageEditorialFaq } from './editorial-faq.interface';
import { defaultImage } from 'projects/app-default/src/app/icms.config';
export const EDITORIAL_FAQ_CONFIG = {
    id: 'editorial-faq',
    name: 'Editorial FAQs',
    tags: ['FAQ'],
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'header',
            title: 'Header',
            default: 'Default - FAQs'
        },
        <NICmsContentField.IChoiceField>{
            key: 'headerSize',
            type: NICmsContentField.EFieldType.choice,
            title: 'Header size',
            options: TextStyleOptions,
            default: 'h1'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'columns',
            title: 'Columns',
            itemName: 'Columns',
            itemNameField: 'columns',
            maxSize: 2,
            fields: [
                <NICmsContentField.IChoiceField>{
                    key: 'variant',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Variant',
                    options: [
                        {
                            key: NPageEditorialFaq.EVariant.image,
                            title: 'Image'
                        },
                        {
                            key: NPageEditorialFaq.EVariant.tabs,
                            title: 'Tabs'
                        }
                    ]
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Section Title',
                    canShow: (data: NPageEditorialFaq.IPageEditorialColumns) => data?.variant === NPageEditorialFaq.EVariant.image
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'header',
                    title: 'Header',
                    canShow: (data: NPageEditorialFaq.IPageEditorialColumns) => data?.variant === NPageEditorialFaq.EVariant.tabs
                },
                <NICmsContentField.IChoiceField>{
                    key: 'headerSize',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Header size',
                    options: TextStyleOptions,
                    canShow: (data: NPageEditorialFaq.IPageEditorialColumns) => data?.variant === NPageEditorialFaq.EVariant.tabs
                },
                <NICmsContentField.IChoiceField>{
                    key: 'questionSize',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Question size',
                    options: TextStyleOptions,
                    canShow: (data: NPageEditorialFaq.IPageEditorialColumns) => data?.variant === NPageEditorialFaq.EVariant.tabs
                },
                <NICmsContentField.IChoiceField>{
                    key: 'answerSize',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Answer size',
                    options: TextStyleOptions,
                    canShow: (data: NPageEditorialFaq.IPageEditorialColumns) => data?.variant === NPageEditorialFaq.EVariant.tabs
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'questions',
                    title: 'Questions',
                    itemName: 'Questions',
                    itemNameField: 'questions',
                    fields: [
                        <NICmsContentField.IField>{
                            key: 'question',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Question'
                        },
                        <NICmsContentField.IField>{
                            key: 'answer',
                            type: NICmsContentField.EFieldType.textarea,
                            title: 'Answer'
                        }
                    ],
                    canShow: (data: NPageEditorialFaq.IPageEditorialColumns) => data?.variant === NPageEditorialFaq.EVariant.tabs
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'ctaLabel',
                    title: 'CTA label',
                    canShow: (data: NPageEditorialFaq.IPageEditorialColumns) => data?.variant === NPageEditorialFaq.EVariant.tabs
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'ctaLink',
                    title: 'CTA link',
                    canShow: (data: NPageEditorialFaq.IPageEditorialColumns) => data?.variant === NPageEditorialFaq.EVariant.tabs
                }
            ],
            default: [
                {
                    questions: [
                        {
                            question: '<h3>Why choose LeMieux products?',
                            answer: "At LeMieux, we’re a diverse team of enthusiastic equestrians with many years of experience owning horses. We want nothing more than to please your horses. That's why we pride ourselves on making innovative, well-made, affordable products that withstand the rigours of horse riding."
                        },
                        {
                            question: '<h3>What types of Saddle Pads does LeMieux offer?',
                            answer: 'You’ll find a wide range of LeMieux saddle pads specially designed for several horse riding disciplines. This includes close contact, dressage, show jumping, and general purpose (GP). Saddle pads have a specific cut for each discipline. The type of saddle pad you choose depends on the shape of your saddle and the discipline you ride.'
                        },
                        {
                            question: '<h3>What are LeMieux Saddle Pads made of?',
                            answer: 'Discover horse saddle pads in various fabrics, including brushed suede, woven satin and cotton. We also have pads made from cooling mesh, merino wool and anti-slip gel.\n <p>&nbsp;</p>\nLeMieux saddle pads come with a 100% bamboo lining that wicks sweat and moisture away from the horse’s skin. Bamboo minimises friction, even on sensitive-skinned horses. Our pads also have a friction-free suede binding that smoothly contours the edges, helping to maintain the perfect saddle shape.\n'
                        },
                        {
                            answer: 'Take a look at our <a href="https://www.lemieuxproducts.com/collections">Colour Collections</a> page to see which colours are best suited to your horse. ',
                            question: '<h3>Which Saddle Pad will suit your horse'
                        }
                    ],
                    variant: 'tabs',
                    headerSize: 'h1',
                    questionSize: 'h2',
                    answerSize: 'p1'
                },
                {
                    questions: [
                        {
                            question: '<h3>How should you look after LeMieux Saddle Pads?',
                            answer: 'Depending on how often you ride, all saddle pads need proper care to ensure they last as long as possible. Always remember to check the care instructions of your saddle pad first.\n <p>&nbsp;</p>\nBefore washing, remove hair, dirt and dried sweat using a stiff brush. You can then pop your saddle pad in the washing machine on a normal 30-degree cycle. Close all fastenings before washing, and make sure the drum is large enough to accommodate the size of your pad.\n <p>&nbsp;</p>\nTo ensure your saddle pad dries correctly, pull it into the correct shape when damp. It’s not a good idea to tumble dry your pad. Instead, air dry it naturally away from a heat source.\n'
                        },
                        {
                            question: '<h3>How often should you replace LeMieux Saddle Pad?',
                            answer: 'This completely depends on how often you ride, how long you ride for and how well you look after it! Looked after well, a LeMieux saddle pad can last for and look good for years. \n<p>&nbsp;</p>\nLeMieux Saddle Pads are very durable and hardwearing, with reinforcement in areas of high friction, but horse riding does lead to a lot of wear and tear. Eventually, all saddle pads need to be replaced. \n'
                        },
                        {
                            question: '<h3>When is your Saddle Pad fitted correctly?',
                            answer: "Our saddle pads are specifically shaped to fit to a horse’s saddle. That’s why it’s important to choose the correct style for your saddle. A correctly-fitting pad should fit your horse’s saddle without creasing, pressing or rubbing. It also shouldn’t impact your horse’s movement. \n<p>&nbsp;</p>\nTo check the fit, ensure the entire surface area of the saddle that is in contact with your horse's back is covered by the saddle pad.  Be sure to pull the girth straps through the girth loops to ensure it doesn’t slip when your horse moves."
                        }
                    ],
                    variant: 'tabs',
                    headerSize: 'h1',
                    questionSize: 'h2',
                    answerSize: 'p1'
                }
            ]
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'ctaLabel',
            title: 'CTA label'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'ctaLink',
            title: 'CTA link'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.colorPicker,
            key: 'backgroundColor',
            title: 'Background Color',
            options: ColorOptions
        },
        <NICmsContentField.IField>{
            key: 'viewMore',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Toggle View More',
            default: false
        }
    ]
};
